/**
 * @fileoverview Company Stage Item Component
 * @active Used in current Next.js App Router routes
 * 
 * This component renders a key-value pair in a styled container,
 * used for displaying company metadata like deal stage and total raised amount.
 * It is part of the current active implementation for the companies card view.
 * 
 * @see {@link src/components/companies/newCompaniesCards/companyNewCardItem/index.tsx} - Parent component
 * @see {@link src/components/companies/newCompaniesCards/index.tsx} - Card view container
 * @see {@link src/components/companies/NewCompanies.tsx} - Main active implementation
 * @see {@link src/components/companies/CompaniesWrapper.client.tsx} - Client wrapper used in App Router
 * @see {@link src/app/(main)/(home)/(research)/companies/page.tsx} - Current App Router page component
 */

import React, { memo } from "react";

import { Flex, Text } from "@chakra-ui/react";

/**
 * Interface for the CompanyStageItem props
 */
interface CompanyStageItemProps {
  keyName: string;
  value: string;
}

/**
 * Company Stage Item component
 * 
 * Displays a key-value pair for company metadata such as deal stage or total raised amount.
 * 
 * @param props - Component props
 * @returns Rendered component
 */
const CompanyStageItem: React.FC<CompanyStageItemProps> = ({ keyName, value }) => {
  return (
    <Flex
      align={"center"}
      justify={"space-between"}
      px={"10px"}
      h={"44px"}
      bg={"menuGray"}
      borderRadius={"4px"}
    >
      <Text>{keyName}</Text>
      <Text>{value}</Text>
    </Flex>
  );
};

export default memo(CompanyStageItem);
